import { render, staticRenderFns } from "./PremiumPaymentWarranty.vue?vue&type=template&id=18d6a165&scoped=true&"
import script from "./PremiumPaymentWarranty.vue?vue&type=script&lang=js&"
export * from "./PremiumPaymentWarranty.vue?vue&type=script&lang=js&"
import style0 from "./PremiumPaymentWarranty.vue?vue&type=style&index=0&id=18d6a165&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d6a165",
  null
  
)

export default component.exports